var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMultisender(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_3",
    "data-name": "Layer 3",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-2{fill:#1b60a3;stroke:none}.cls-3{fill:#39beec}\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m438.379 387.463-50.912 50.912L224.543 275.45l50.911-50.911z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m402.65 402.65-55.33 55.32 75.57 20.25 75.57 20.24-20.24-75.57-20.25-75.57-55.32 55.33z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m275.457 224.544-50.912 50.911L61.621 112.531l50.912-50.912z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m97.35 97.35-55.32 55.33-20.25-75.57L1.54 1.54l75.57 20.24 75.57 20.25-55.33 55.32z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m387.472 61.612 50.912 50.911-162.925 162.925-50.912-50.912z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m402.65 97.35 55.32 55.33 20.25-75.57 20.24-75.57-75.57 20.24-75.57 20.25 55.33 55.32z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m224.534 224.542 50.912 50.912-162.924 162.924-50.912-50.912z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m97.35 402.65 55.33 55.32-75.57 20.25-75.57 20.24 20.24-75.57 20.25-75.57 55.32 55.33z"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 250,
    r: 123.36,
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultisender);
export default __webpack_public_path__ + "static/media/Multisender.c3dacd9c83f01a6056b370e416bfe30a.svg";
export { ForwardRef as ReactComponent };